const inputList = {
  reset: {
    symbol: 'AC',
    isLeft: false,
    isOperation: true,
  },

  plusOrMinus: {
    symbol: '+/-',
    isLeft: false,
    isOperation: true,
  },

  modules: {
    symbol: '%',
    isLeft: false,
    isOperation: true,
  },

  divide: {
    symbol: '÷',
    isLeft: true,
    isOperation: true,
  },

  seven: {
    symbol: '7',
    isLeft: false,
    isOperation: false,
  },

  eight: {
    symbol: '8',
    isLeft: false,
    isOperation: false,
  },
  nine: {
    symbol: '9',
    isLeft: false,
    isOperation: false,
  },

  multiply: {
    symbol: 'x',
    isLeft: true,
    isOperation: true,
  },

  four: {
    symbol: '4',
    isLeft: false,
    isOperation: false,
  },

  five: {
    symbol: '5',
    isLeft: false,
    isOperation: false,
  },

  six: {
    symbol: '6',
    isLeft: false,
    isOperation: false,
  },

  minus: {
    symbol: '-',
    isLeft: true,
    isOperation: true,
  },

  one: {
    symbol: '1',
    isLeft: false,
    isOperation: false,
  },

  two: {
    symbol: '2',
    isLeft: false,
    isOperation: false,
  },

  three: {
    symbol: '3',
    isLeft: false,
    isOperation: false,
  },

  plus: {
    symbol: '+',
    isLeft: true,
    isOperation: true,
  },

  zero: {
    symbol: '0',
    isLeft: false,
    isOperation: false,
  },

  dot: {
    symbol: '.',
    isLeft: false,
    isOperation: false,
  },

  equal: {
    symbol: '=',
    isLeft: true,
    isOperation: true,
  },

};

export default inputList;
